import {IUser, UserRoles} from "../User/UserTypes";

export default class StrapiPermissionsUtil {

    static isRole(checkRole:UserRoles|UserRoles[], user?:IUser){
        if (!user) {
            return false;
        }
        if (Array.isArray(checkRole)){
            let isRole = false;
            checkRole.forEach(role => {
                if (user?.role?.name === role){
                    isRole = true;
                }
            })
            return isRole;
        } else {
            return user.role?.name === checkRole;
        }
    }

    static isCorlAdminOrEmployee(user?:IUser){
        return StrapiPermissionsUtil.isRole([UserRoles.CorlAdmin, UserRoles.CorlEmployee], user);
    }

    static isCorlAdmin(user?:IUser){
        return StrapiPermissionsUtil.isRole([UserRoles.CorlAdmin], user);
    }

    static isVendorUser(user?:IUser){
        return StrapiPermissionsUtil.isRole([UserRoles.VendorAdmin, UserRoles.VendorEmployee, UserRoles.CorlAdmin], user);
    }
    static isVendorAdmin(user?:IUser){
        return StrapiPermissionsUtil.isRole([UserRoles.VendorAdmin, UserRoles.CorlAdmin], user);
    }
    static isClientUser(user?:IUser){
        return StrapiPermissionsUtil.isRole([UserRoles.ClientAdmin, UserRoles.ClientEmployee, UserRoles.CorlAdmin], user);
    }
    static isClientAdmin(user?:IUser){
        return StrapiPermissionsUtil.isRole([UserRoles.ClientAdmin, UserRoles.CorlAdmin], user);
    }

}